import   React  from 'react';
		 
import   classNames                             from 'classnames';

import   styles                                 from './AdsCampaignRow.module.scss';

import { AdsCampaign                       }  from '../../../dataTypes/adsCampaignManagment/types';

import   Icon                                   from '../../widget/images/Icon';


import { convertDateToString                 }  from '../../../dataTypes/timeManagment/utils';

interface AdsCampaignRowProps {
  adsCampaign      : AdsCampaign;
  index              : number;
  onEdit             : (index: number) => void;
  onDelete           : (adsCampaign: AdsCampaign) => void;
}

export const AdsCampaignRow = ({ adsCampaign      ,
                                   index              ,
                                   onEdit             ,
                                   onDelete           }: AdsCampaignRowProps) => {


  return (
    <div className={classNames(styles.row)}>
      <div className={classNames(styles.column_1, styles.standard)}>
        {adsCampaign.id}
      </div>
      <div className={classNames(styles.column_2, styles.standard)} >
        {adsCampaign.name}
      </div>
      <div className={classNames(styles.column_3, styles.standard)}>
        {convertDateToString (adsCampaign.beginningDate, 'dd/MM/yyyy HH:mm')}
      </div>
      <div className={classNames(styles.column_4, styles.standard)}>
        {convertDateToString (adsCampaign.endingDate, 'dd/MM/yyyy HH:mm')}
      </div>
      <div className={classNames(styles.column_5, styles.standard)}>
		
      </div>
      <div className={classNames(styles.column_6, styles.standard)}>
        <Icon name       = "pen"
              onClick    = {() => onEdit(index)}
		      color      = "#000000"
              hoverColor = "#4421AA" />
        &nbsp;
        <Icon name       = "trashCan"
              onClick    = {() => onDelete(adsCampaign)}
		      color      = "#000000"
              hoverColor = "#4421AA" />
      </div>
      <div className={classNames(styles.column_7, styles.standard)}>

      </div>
    </div>
  );
};

export default AdsCampaignRow;
